// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.size-selector {
  width: -moz-fit-content;
  width: fit-content;
  min-height: 28px !important;
  height: 28px;
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/paginator/paginator.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EAAA,kBAAA;EACA,2BAAA;EACA,YAAA;EACA,iBAAA;AACJ","sourcesContent":[".size-selector {\n    width: fit-content;\n    min-height: 28px !important;\n    height: 28px;\n    font-size: 0.9rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
